document.querySelectorAll('input.needReinstall').forEach(function (el) {
	addEventListener('keydown', function() {
		document.getElementById('reinstall').classList.remove('hidden');
	}
)});
document.querySelectorAll('.find input').forEach(function (el) {
	addEventListener('keyup', function(el) {
		if(el.target.value==''){
			document.querySelector(".main").classList.remove('finding');
			document.querySelectorAll(".finded").forEach(function(el){el.classList.remove('finded');});
		}else{
			document.querySelector(".main").classList.add('finding');
			document.querySelectorAll(".finded").forEach(function(el){el.classList.remove('finded');});
			document.querySelectorAll("p[data-for-find*=\"" + el.target.value + "\"]").forEach(function(el){el.classList.add('finded');});
		}
	}
)});